<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';
import { useAlert } from 'dashboard/composables';
import WootButton from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const props = defineProps({
    conversationId: {
        type: [Number, String],
        required: true,
    },
    conversationAdditionalAttributes: {
        type: Object,
        default: () => ({}),
    },
});

const ctwaClid = computed(() => props.conversationAdditionalAttributes['ctwa_clid'] || '');

const events = [
    // Eventos básicos
    { type: 'Purchase', label: 'Compra realizada' },
    { type: 'Lead', label: 'Lead gerado' },
    { type: 'CompleteRegistration', label: 'Cadastro completo' },
    // Eventos essenciais
    { type: 'InitiateCheckout', label: 'Início do checkout' },
    { type: 'AddToCart', label: 'Adicionar ao carrinho' },
    { type: 'ViewContent', label: 'Visualizar conteúdo' },
];

const loading = ref(false);

const sendEvent = async eventType => {
    if (!ctwaClid.value) {
        useAlert('CTWA CLID não encontrado na conversa');
        return;
    }
    loading.value = true;
    try {
        await axios.post('/ctwa_events', {
            ctwa_clid: ctwaClid.value,
            event_type: eventType,
            payload: {},
        });
        useAlert(`Evento "${eventType}" enviado com sucesso!`);
    } catch (e) {
        useAlert(`Erro ao enviar evento: ${e?.response?.data?.error || e.message}`);
    } finally {
        loading.value = false;
    }
};
</script>

<template>
    <div class="py-2">
        <div v-if="loading" class="flex items-center justify-center min-h-[140px]">

            <Spinner size="small" color-scheme="primary" class="max-w-10 max-h-10" />
        </div>
        <div v-else class="grid grid-cols-2 gap-2">
            <WootButton v-for="event in events" :key="event.type" :label="event.label" color="blue" variant="solid"
                size="sm" class="w-full min-w-[140px]" @click="sendEvent(event.type)" />
        </div>
    </div>
</template>

<style scoped>
.min-h-140px {
    min-height: 140px;
}
</style>